import { http } from "@/communication";

/**
 * create a CRUD based resource module in vuex
 *
 * @param {String} name
 */
export const settingModule = {
  namespaced: true,
  state: { settings: {} },
  actions: {
    all({ commit }) {
      return http.get("/api/v1/setting").then(({ data }) => {
        commit("update", data);
      });
    },
    update(store, data) {
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        if (key !== "sidebarStore") {
          formData.append(`key[${key}]`, data[key]);
        }
      });
      return http.post("/api/v1/setting", formData);
    }
  },
  mutations: {
    update(state, data) {
      state.settings = data.reduce((accumulator, setting) => {
        accumulator[setting.key] = setting.value;
        return accumulator;
      }, state.settings);
    }
  },
  getters: {
    key: ({ settings }) => key => {
      return settings[key];
    },
    all({ settings }) {
      return settings;
    }
  }
};
